/**
 * The Scheduling save's id, sent as `X-Save-Id` on every request made while the save runs, so the
 * API's audit log can group that save's writes. Ambient rather than threaded through each port:
 * one save runs at a time, and a read that happens to go out mid-save and carry the id is
 * harmless — reads are not audit-logged.
 */
let currentSaveId: string | null = null;

/** `crypto.randomUUID` is missing outside secure contexts (the sandbox served over a LAN IP). */
function newSaveId(): string {
	return globalThis.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

export async function withSaveId<T>(run: () => Promise<T>): Promise<T> {
	currentSaveId = newSaveId();
	try {
		return await run();
	} finally {
		currentSaveId = null;
	}
}

/** The header to add while a save runs; empty otherwise. */
export function saveIdHeader(): Record<string, string> {
	return currentSaveId ? { "X-Save-Id": currentSaveId } : {};
}
